const AboutSection = () => {
	return (
		<section className="op-inScreen overflow-hidden my-8">
			<h1 className="text-center text-[3.5rem] font-cairo font-bold">عني</h1>
			<div className="relative flex flex-col-reverse justify-center items-center gap-44 my-8 lg:flex-row">
				<img
					id="about-bg"
					className="hidden absolute top-[00%] w-7/12 -z-10 opacity-10 left-[-15%] lg:block"
					src="./assets/abbg-me.svg"
					alt=""
				/>
				<p className="max-w-[500px] text-center text-[7vw] lg:text-4xl lg:text-start">
					عاشق للتصوير منذ الصغر، هدفي الأساسي نشر جمال بلادي للعالم لكي يرى كل العالم جمال فلسطين بشكل عام و القدس بشكل خاص.
					<br />
					<br />
					التصوير بالمقام الأول هو تفريغ طاقات بالنسبة لي. مستمر في تعلمه حتى الآن لانه عالم واسع.
				</p>
				<img id="about-img" className="w-3/5 rounded-2xl lg:w-1/5" src="./assets/ab-img.jpg" alt="" />
			</div>
		</section>
	);
};

export default AboutSection;
